import { Fragment } from "react";
import styled from "styled-components";
import { Typography, Checkbox, Grid } from "@mui/material";
import { ToggleOnOutlined, ToggleOffOutlined } from "@mui/icons-material";

import Input from "./audience fields/Input";
import Range from "./audience fields/Range";
import DropDown from "./audience fields/Dropdown";
import DatePicker from "./audience fields/DatePicker";
import AudienceName from "./audience fields/AudienceName";
import { ComponentHeader, Paper } from "../../../components";
import { colors } from "../../css components/Style";

const Heading = styled(Typography)`
  font-size: 15px;
  font-weight: 500;
  line-height: 27px;
  align-self: center;
`;

export default function FormOne({
  setFields,
  state,
  categories,
  dispatch,
  fields,
  editState,
  formikProps,
  setButtonDisable,
}) {
  return (
    <Fragment>
      <Paper>
        <Grid size={12}>
          <ComponentHeader
            title={"Audience"}
            subtitle={
              formikProps.values.ID
                ? "Audience group details"
                : "Give audience group a name"
            }
          />
        </Grid>

        <Grid size={12}>
          <Typography color={colors.error} variant="caption1">
            NOTE : Mark any one of the filled field as mandatory.
          </Typography>
        </Grid>

        <AudienceName
          setFields={setFields}
          state={state}
          dispatch={dispatch}
          editState={editState}
          formikProps={formikProps}
        />
      </Paper>

      {categories?.map(
        (category) =>
          fields.find((f) => f.category?.category_title === category) && (
            <Paper gridSpacing={6}>
              <Grid size={12}>
                <Typography variant="h5" color={colors.purple}>
                  {category !== "Others" && category}
                </Typography>
              </Grid>

              {fields.map(
                (field) =>
                  field.category?.category_title === category && (
                    <Fragment>
                      {field.control_id === 3 && (
                        <Input
                          setButtonDisable={setButtonDisable}
                          state={state}
                          dispatch={dispatch}
                          editState={editState}
                          field={field}
                          formikProps={formikProps}
                        />
                      )}

                      {field.control_id === 1 && (
                        <Range
                          setButtonDisable={setButtonDisable}
                          state={state}
                          dispatch={dispatch}
                          editState={editState}
                          field={field}
                          formikProps={formikProps}
                        />
                      )}

                      <DropDown
                        state={state}
                        dispatch={dispatch}
                        editState={editState}
                        field={field}
                        formikProps={formikProps}
                      />

                      {field.control_id === 4 && (
                        <DatePicker
                          state={state}
                          dispatch={dispatch}
                          editState={editState}
                          field={field}
                          formikProps={formikProps}
                        />
                      )}
                    </Fragment>
                  )
              )}
            </Paper>
          )
      )}
    </Fragment>
  );
}

export function Mandatory({ state, field, dispatch, editState }) {
  function handleCheckChange(value, name, key) {
    dispatch({
      type: "CALCULATE_PERCENTAGE",
      payload: { value, name, key },
    });
  }

  return (
    <div style={{ display: "flex", justifyContent: "end" }}>
      <Heading
        style={{
          color: state?.[field.name]?.mandatory ? "red" : "gray",
        }}
      >
        Mandatory
      </Heading>

      <Checkbox
        style={{ padding: "3px 9px" }}
        disabled={
          field.control_id === 1
            ? !state?.[field.name]?.value?.min ||
              !state?.[field.name]?.value?.max ||
              !editState
            : !editState ||
              !state?.[field.name]?.value ||
              state?.[field.name]?.value?.length === 0
        }
        name={`${field.name}.mandatory`}
        onChange={(e) => {
          handleCheckChange(e.target.checked, field.name, "mandatory");
        }}
        checked={state?.[field.name]?.mandatory}
        icon={<ToggleOffOutlined fontSize="large" />}
        checkedIcon={
          <ToggleOnOutlined
            fontSize="large"
            style={{
              color: state?.[field.name]?.mandatory ? "red" : "#cbcbcb",
            }}
          />
        }
      />
    </div>
  );
}
